import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, ViewChildren, ViewChild, QueryList } from "@angular/core";
import { delay, SharedService } from '../../shared'
import { SplitComponent, SplitAreaDirective } from 'angular-split';
import { IExtraOptionAnswer, LANGUAGE_ENUM } from "../questionnaire.model";


@Component({
    selector: 'icd-code-popup',
    templateUrl: "./icd-code-popup.component.html",
    styleUrls: ["./icd-code-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ICDCodePopupComponent implements OnInit {
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    @ViewChild(SplitComponent) splitEl: SplitComponent
    @ViewChildren(SplitAreaDirective) areasEl: QueryList<SplitAreaDirective>

    @Input() selectedOptions: IExtraOptionAnswer[] = [];

    LANGUAGE_ENUM = LANGUAGE_ENUM;
    showLoader: boolean = false;

    icdCode: string = "";
    icdText: string = "";
    fuzzyFilter: boolean = false;

    allCodeList: any = [] = [];
    filteredCodeList: any = [] = [];

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        this.getICDCodeList();
    }

    getICDCodeList() {
        this.showLoader = true;
        this.sharedService.getICD10Codes().subscribe(
            res => {
                this.showLoader = false;
                this.allCodeList = res;
                this.filteredCodeList = [...this.allCodeList];
            },
            err => {
                this.showLoader = false;
            }
        )
    }

    fnSwitchToggle() {
        this.fuzzyFilter = !this.fuzzyFilter;
        this.filterICDRecords();
    }

    filterICDRecords() {
        if (this.fuzzyFilter) {
            const result = this.sharedService.fuzzySearch(this.allCodeList, 't', this.icdText);
            this.filteredCodeList = this.sharedService.fuzzySearch(result, 'c', this.icdCode);
        } else {
            this.filteredCodeList = this.allCodeList.filter(a => a.c.toLowerCase().indexOf(this.icdCode.toLowerCase()) >= 0 && a.t.toLowerCase().indexOf(this.icdText.toLowerCase()) >= 0);
        }
    }

    getOptionText(item) {
        return `${item.t} ${item.c}`;
    }

    checkCodeItemSelected(item: any) {
        const option = this.getOptionText(item);
        return this.selectedOptions.findIndex(a => a["label"] == option || a.value == option) > - 1 ? true : false;
    }

    selectThisCodeItem(item) {
        const option = this.getOptionText(item);
        const index = this.selectedOptions.findIndex(a => a.value == option);
        if (index === -1) {
            var obj = { value: option };
            if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
                obj["label"] = option;
                obj["risk"] = true;
            }
            this.selectedOptions.push(obj);
        } else {
            this.removeItem(index);
        }
    }

    moveItemUp(index) {
        this.moveItem(index, index - 1);
    }

    moveItemDown(index) {
        this.moveItem(index, index + 1);
    }

    moveItem(from, to) {
        // remove `from` item and store it
        var f = this.selectedOptions.splice(from, 1)[0];
        // insert stored item into position `to`
        this.selectedOptions.splice(to, 0, f);
    }

    removeItem(index) {
        this.selectedOptions.splice(index, 1);
    }

}
